export default __webpack_public_path__ + "static/media/AdobeStock_346805525_x3.f3d4f982.jpg";